import {
  GLOBAL_KEYWORD_CHANGE,
  GLOBAL_SAVED_AUTHORS_CHANGE,
  GLOBAL_USER_SEARCHES_CHANGE,
  CURRENT_SAVED_AUTHOR_CHANGE
} from "../actions/types";

const initialState = {
  globalKeyword: "",
  savedAuthors: {
    isPageLoading: false,
    isPageOpen: false,
    currentPageResults: [],
    skip: 0,
    limit: 10,
    firstPageResults: [],
    pageNumber: 1,
    Total: null
  },
  userSearches: {
    isPageLoading: false,
    isPageOpen: false,
    currentPageResults: [],
    skip: 0,
    limit: 10,
    firstPageResults: [],
    pageNumber: 1,
    Total: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_KEYWORD_CHANGE:
      return {
        ...state,
        globalKeyword: action.payload.keyword
      };
      break;
    case GLOBAL_SAVED_AUTHORS_CHANGE:
      return {
        ...state,
        savedAuthors: action.payload.savedAuthors
      };
      break;
    case GLOBAL_USER_SEARCHES_CHANGE:
      return {
        ...state,
        userSearches: action.payload.userSearches
      };
      break;
    case CURRENT_SAVED_AUTHOR_CHANGE:
      let recentResults = [...action.payload].map(l=>{
          return {
              qurey: l.query,
              created: Date.now(),
              info:l.info,
              name: l.name
          }
      })
      let currentPageResults = [...recentResults, ...state.savedAuthors.currentPageResults]
      let savedAuthors = {
          ...state.savedAuthors,
          currentPageResults
      }
      return {
        ...state,
        savedAuthors: savedAuthors
      };
      break;
    default:
      return state;
      break;
  }
};
